import config from "./config";

/**
 * WalletConnect / Reown Verify matches metadata.url to the page origin.
 * In an iframe the app runs on the iframe origin, not rpay.inc.
 */
export function resolveAppKitMetadata() {
  let url = config.brand.publicUrl || "https://rpay.inc";
  if (typeof window !== "undefined" && window.location?.origin) {
    url = window.location.origin;
  }

  return {
    name: config.brand.name,
    description: `Pay with ${config.brand.name}`,
    url,
    icons: [
      "https://ik.imagekit.io/rocketfuel/icons/rocketfuel-circular.svg?updatedAt=1726663710853",
    ],
  };
}
